'use strict';

import * as angular from 'angular';
import IContainer from '../../../server/api/container/container.interface';
import * as _ from 'lodash';
import {ModalContainerSaveFileService} from '../modalContainerSaveFile/modalContainerSaveFile.controller';
import * as URL from 'url';

class ContainerWMController{
  private container;

  constructor(/* private scope, */ private $scope, private $timeout, private $http, private $uibModal, private $filter, private $cookies, private Container, private Auth, private User, private ModalContainerSaveFileService:ModalContainerSaveFileService, private ga){
    this.container = $scope.container;
  }

  setDomainCookie(){
    if(! this.$cookies.get('paiza-user-set-domain-cookie')) {
      window.open('https://paiza-user.cloud/set-domain-cookie.html', '_blank'); // TODO: コンフィグで環境によって切り替える
      this.$cookies.put('paiza-user-set-domain-cookie', 'ok', {samesite: "None", secure: true});
    }
  }

  deleteWindowModel(windowModel){
    if(windowModel.ctrl.close){
      windowModel.ctrl.close(true);
    }
    this.container.deleteWindowModel(windowModel);
  }

  openTerminal(windowModels, command){
    const windowModel = {
      application: 'tty',
      model: {
        command: command,
      },
      ctrl: {},
    };
    this.container.addWindowModel(windowModels, windowModel);
    this.container.activateWindowModel(windowModel);
  }

  openEditor(windowModels, options = {}){
    Object.assign(options, {extensions: ['txt']});
    this.ModalContainerSaveFileService.open(this.container, options, 'new')
      .then((filename) => {
        const windowModel = {
          application: 'editor',
          model: {
            filename: filename,
          },
          ctrl: {},
        };
        this.container.addWindowModel(windowModels, windowModel);
        this.container.activateWindowModel(windowModel);
      });
  }

  openFinder(windowModels, dir){
    const windowModel = {
      application: 'file-tree',
      model: {
        node: {text: dir, id: dir, children: true, icon: 'jstree-folder'},
      },
      ctrl: {},
    };
    this.container.addWindowModel(windowModels, windowModel);
    this.container.activateWindowModel(windowModel);
  }
  openBrowser(windowModels, url){
    const windowModel = {
      application: 'browser',
      model: {
        url: url,
      },
      ctrl: {},
    };
    this.container.addWindowModel(windowModels, windowModel);
    this.container.activateWindowModel(windowModel);
  }
  openBrowserForLocalhost(windowModels, port, bLocalhost) {
    const url = 'https://' + (bLocalhost ? 'localhost-' : '') + this.container.containerHostname + ((port && port !== 80) ? (':' + port) : '') + '/';
    return this.openBrowser(windowModels, url);
  }

  openCustomApplication(windowModels, application){
    const windowModel = {
      application: 'customapplication',
      model: {
        type: application.type,
        applicationId: application._id,
        url: application.url,
        files: application.files,
        name: application.name,
      },
      ctrl: {},
    };
    this.container.addWindowModel(windowModels, windowModel);
    this.container.activateWindowModel(windowModel);
  }

  changeWindowManager(wm){
    let msg = this.container.ctrl.onbeforeunload && this.container.ctrl.onbeforeunload();
    if(msg){
      if(!window.confirm(msg)){ // eslint-disable-line no-alert
        return;
      }
    }

    this.container.desktop.wm = wm;
    console.log('changeWindowManager', wm);
    this.$scope.$broadcast('windowManager.change', wm);

    this.saveDesktop();
    // location.href = location.origin + '/containers/' + scope.container.containerIdShort + '/show' + '?wm=' + wm;
    // location.href = location.origin + location.pathname + '?wm=' + wm;
  }

  openPhpmyadmin(windowModels){
    const windowModel = {
      application: 'browser',
      model: {
        // url: 'https://' + this.container.containerHostname + '/phpmyadmin/',
        url: 'https://localhost/phpmyadmin/',
      },
      ctrl: {},
    };
    this.container.addWindowModel(windowModels, windowModel);
    this.container.activateWindowModel(windowModel);
  }

  saveDesktop(){
    return this.container.saveDesktop();
  }
}

angular.module('paizacloudApp')
  .directive('containerwm', function($uibModal, $interval, $http:ng.IHttpService, socket, Container, $timeout, $translate, $controller, User, Auth) {
    return {
      templateUrl: 'app/containerwm.directive/containerwm.directive.html',
      restrict: 'EA',
      scope: {
        container: '=',
        controller: '=',
        onRemove: '&',
      },
      controller: ContainerWMController,
      link: function(scope:any, element, attrs, ctrl) {
        // let wmCtrl = scope.controller;
        scope.socketAlert = {type: 'warning', msg: 'Test message'};

        scope.controller = ctrl;
        // scope.controller = $controller(ContainerWMController, {scope: scope});

        element[0].addEventListener('keydown', function(event){
          console.log('containerwm:element.keydown', event);
        }, true);
        element[0].addEventListener('click', function(event){
          console.log('containerwm:element.click', event);
        }, true);
        scope.$on('iframeClick', function(event){
          console.log('containerwm:iframeClick', event);
        });
        scope.$on('open:browser', (event, url) => {
          scope.controller.openBrowser(null, url);
        });
        scope.appName = 'myapp';

        const checkAlive = (container) => {
          console.log('checkAlive');
          if(!container._id){
            return;
          }
          Container.get({id: container._id, container_token: container.containerToken}).$promise
            .then((container_) => {
              console.log("checkAlive: /api/containers/ response:", container_);
              container.merge(container_);
              console.log('container.state=', scope.container.state);
            })
            .catch((response) => {
              console.log("Container not found: response:", response);
              if (response.status === 404) {
                container.state = 'closed';
                container.close();
                scope.onRemove({container: container});
              }
            });
        };

        let onConnect = function(){
          console.log('containerwm:onConnect');
          if(scope.container.state !== 'closed'){
            checkAlive(scope.container);
          }
        };
        socket.socket.on('reconnect', onConnect);

        scope.$on('$destroy', function(){
          socket.socket.removeListener('reconnect', onConnect);
          scope.container.socket.removeListener('reconnect', onConnect);
        });

        scope.$watch('container.containerId', function(post, pre){
          console.log("containerwm:watch:container.containerId", post, pre);
          if(!post){
            scope.container.disconnectSocket();
            return;
          }
          scope.container.connectSocket();

          ['disconnect', 'connect', 'reconnect', 'reconnect_attempt', 'reconnecting', 'reconnect_error', 'reconnect_attempt', 'reconnect_failed', 'error', 'connect_error', 'connect_timeout', 'reconnect_error'].forEach((event) => {
            scope.container.socket.ioSocket.on(event, (err) => {
              console.log(`event=${event}`, err, scope.container.socket.ioSocket.io, scope.container.socket.ioSocket.io.backoff);
              scope.container.readyState = scope.container.socket.ioSocket.io.readyState;
              scope.container.reconnectAttempts = scope.container.socket.ioSocket.io.backoff.attempts;
            });
          });
          scope.container.socket.on('clients:update', (clients) => {
            console.log('socket.on:clients:update', clients);
            scope.container.clients = clients;
          });

          scope.container.socket.on('open:browser', (url) => {
            const windowModel = {
              application: 'browser',
              model: {
                url: url,
              },
            };
            scope.container.addWindowModel(null, windowModel);
            scope.container.activateWindowModel(windowModel);
          });
          scope.container.socket.on('open:editor', (filename) => {
            const windowModel = {
              application: 'editor',
              model: {
                filename: filename,
              },
            };
            scope.container.addWindowModel(null, windowModel);
            scope.container.activateWindowModel(windowModel);
          });


          scope.container.socket.on('reconnect', onConnect);
        });
        scope.$on('$destroy', function(){
          if(scope.container){
            scope.container.close();
          }
        });


        function socketLeave(){
          console.log('containerwm:socketLeave');
          socket.socket.emit('container:leave', scope.container._id, () => {
            socket.socket.removeAllListeners('container:' + scope.container._id + ':save');
            socket.socket.removeAllListeners('container:' + scope.container._id + ':remove');
          });
        }
        let socketJoinDone = false;
        function socketJoin(){
          if(socketJoinDone){
            return;
          }
          socketJoinDone = true;
          console.log('containerwm:socketJoin');
          socket.socket.emit('container:join', scope.container._id, () => {
            socket.socket.on(`container:${scope.container._id}:save`, (updated:IContainer) => {
              console.log(`container:${scope.container._id}:save`, updated, updated.updatedBy, socket.ioSocket.id);
              if(updated.updatedBy && updated.updatedBy === socket.ioSocket.id){
                console.log('Sender is me. ignoring the event');
                return;
              }
              scope.$apply(() => {
                scope.container.merge(updated);
                console.log('container.state=', scope.container.state);
              });
            });
            socket.socket.on(`container:${scope.container._id}:remove`, () => {
              console.log('container:${scope.container._id}:remove');
              if(scope.container.state !== 'closed'){
                checkAlive(scope.container);
              }
            });
          });
        }
        if(socket.ioSocket.connected){
          console.log('containerwm:connected');
          socketJoin();
        }
        socket.socket.on('connect', () => {
          console.log('containerwm:connect event');
          socketJoin();
        });
        scope.$on('$destroy', () => {
          socketLeave();
        });


        scope.$watch('container.socket', (post, pre) => {
          if(!post){
            scope.container.listenStats = [];
            return;
          }
          let fListening = false;
          function listener(listenStats){
            console.log('listenStats:updated', listenStats);
            listenStats = listenStats.filter((l) => l === listenStats.find((l_) => l_.address === l.address && l_.port === l.port));
            listenStats = listenStats.filter((l) => {
              if([8005, 8009].indexOf(l.port) >= 0 && l.command === 'java'){
                return false; // Tomcat
              }
              return l.port === 80 || (l.port >= 1024 && l.port <= 32767 && [3008, 3009, 3306, 5432, 5433, 27017, 28017, 17080, 6379, 11211].indexOf(l.port) === -1);
            }); // https://attackerkb.com/Scanning/ports
            scope.container.listenStats = listenStats;
          }
          function onConnect(){
            if(fListening){
              return;
            }
            console.log('listenStats:updated onConnect');
            scope.container.socket.on('listenStats:updated', listener);
            scope.container.socket.emit('watchlistenStats');
            fListening = true;
          }
          function onDisconnect(){
            console.log('listenStats:updated onDisconnect');
            if(scope.container.socket) {
              scope.container.socket.emit('unwatchlistenStats');
              scope.container.socket.removeListener('listenStats:updated', listener);
              fListening = false;
            }
          }
          onConnect();
          scope.$on('$destroy', onDisconnect);
          scope.container.socket.on('connect', onConnect);
          scope.container.socket.on('disconnect', () => {
            console.log('listenStats:updated socket disconnect');
            onDisconnect();
          });
        });


      },
    };
  })
  .filter("tabWindowModelFilter", function($filter){
    let result:any[] = [];
    return function(windowModels){
      // return windowModels.filter((windowModel) => windowModel.application !== 'file-tree');

      result.splice(0, result.length);
      windowModels.forEach(function(item){
        if(item.application !== 'file-tree'){
          result.push(item);
        }
      });
      return result;

    };
  })
  .filter("sidebarWindowModelFilter", function($filter){
    let result:any[] = [];
    return function(windowModels){
      // return windowModels.filter((windowModel) => windowModel.application === 'file-tree');
      result.splice(0, result.length);
      windowModels.forEach(function(item){
        if(item.application === 'file-tree'){
          result.push(item);
        }
      });
      return result;

    };
  });
